import React, { useState } from 'react';
import { FormElement, FormSelector, FormLabel, FormInput, FormNumberInput, PageSubTitle } from "../components/StyledElements";
import { Handle, Position } from '@xyflow/react';
import { NodeCard } from './NodeCard';
import { CloseButton } from '../components/CloseButton';

export const TextSplittingNodeCard = ({ onAdd = () => { }, style = {} }) => {
  return (
    <NodeCard title="Text Splitting Node" description="Configure the text splitting method and parameters for chunking your documents." onAdd={onAdd} style={style} />
  )
};

export const TextSplittingNode = ({ id, data }) => {
  const [method, setMethod] = useState(data.method || "fixed-size");
  const [chunkSize, setChunkSize] = useState(data.chunkSize || 1000);
  const [overlapSize, setOverlapSize] = useState(data.overlapSize || 200);
  const [minChunkSize, setMinChunkSize] = useState(data.minChunkSize || 100);
  const [maxChunkSize, setMaxChunkSize] = useState(data.maxChunkSize || 2000);
  const [maxSentences, setMaxSentences] = useState(data.maxSentences || 5);
  const [sentenceOverlap, setSentenceOverlap] = useState(data.sentenceOverlap || 1);
  const [maxTokens, setMaxTokens] = useState(data.maxTokens || 500);
  const [tokenOverlap, setTokenOverlap] = useState(data.tokenOverlap || 50);
  const [clusterSize, setClusterSize] = useState(data.clusterSize || 0);
  const [nerMaxChunkSize, setNerMaxChunkSize] = useState(data.nerMaxChunkSize || 1000);
  const [cdMinChunkSize, setCdMinChunkSize] = useState(data.cdMinChunkSize || 100);
  const [cdMaxChunkSize, setCdMaxChunkSize] = useState(data.cdMaxChunkSize || 2000);

  return (
    <div style={{ display: "flex", flexDirection: "column", padding: "10px", border: "1px solid var(--main-border-color)", borderRadius: "8px", backgroundColor: "var(--content-item-bg)" }}>
      <CloseButton onClick={() => {
        data.onDelete(id);
      }} />
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <FormLabel label="Text Splitting Node" />
        <FormElement>
          <FormLabel label="Method" />
          <FormSelector value={method}
            options={[
              { value: "fixed-size", label: "Fixed Size" },
              { value: "recursive", label: "Recursive" },
              { value: "document-based", label: "Document-based" },
              { value: "sentence-based", label: "Sentence-based" },
              { value: "token-based", label: "Token-based" },
              { value: "semantic", label: "Semantic" },
              { value: "ner", label: "Named Entity Recognition" },
              { value: "content-density", label: "Content Density" },
            ]}
            onChange={(e) => {
              setMethod(e.target.value);
            }}
          />
        </FormElement>
        {
          method === "fixed-size" && (
            <>
              <FormElement>
                <FormLabel label="Chunk Size (in characters)" />
                <FormNumberInput value={chunkSize}
                  onChange={(e) => {
                    console.log("!!! CHUNK SIZE CHANGE: ", e.target.value, parseInt(e.target.value));
                    setChunkSize(Number(e.target.value));
                  }} />
              </FormElement>
              <FormElement>
                <FormLabel label="Overlap Size (in characters)" />
                <FormNumberInput value={overlapSize}
                  onChange={(e) => {
                    console.log("!!! OVERLAP SIZE CHANGE: ", e.target.value, parseInt(e.target.value));
                    setOverlapSize(Number(e.target.value));
                  }}
                />
              </FormElement>
            </>
          )
        }
        {
          method === "recursive" && (
            <>
              <FormElement>
                <FormLabel label="Min Chunk Size (in characters)" />
                <FormNumberInput value={minChunkSize}
                  onChange={(e) => {
                    console.log("!!! CHUNK SIZE CHANGE: ", e.target.value, parseInt(e.target.value));
                    setMinChunkSize(Number(e.target.value));
                  }} />
              </FormElement>
              <FormElement>
                <FormLabel label="Max Chunk Size (in characters)" />
                <FormNumberInput value={maxChunkSize}
                  onChange={(e) => {
                    console.log("!!! CHUNK SIZE CHANGE: ", e.target.value, parseInt(e.target.value));
                    setMaxChunkSize(Number(e.target.value));
                  }} />
              </FormElement>
            </>
          )
        }
        {
          method === "sentence-based" && (
            <>
              <FormElement>
                <FormLabel label="Max Sentences" />
                <FormInput value={maxSentences}
                  onChange={(e) => {
                    console.log("!!! LANGUAGE CHANGE: ", e.target.value);
                    setMaxSentences(Number(e.target.value));
                  }} />
              </FormElement>
              <FormElement>
                <FormLabel label="Overlap Size (in sentences)" />
                <FormNumberInput value={sentenceOverlap}
                  onChange={(e) => {
                    console.log("!!! OVERLAP SIZE CHANGE: ", e.target.value, parseInt(e.target.value));
                    setSentenceOverlap(Number(e.target.value));
                  }}
                />
              </FormElement>
            </>
          )
        }
        {
          method === "token-based" && (
            <>
              <FormElement>
                <FormLabel label="Max Tokens" />
                <FormInput value={maxTokens}
                  onChange={(e) => {
                    setMaxTokens(Number(e.target.value));
                  }} />
              </FormElement>
              <FormElement>
                <FormLabel label="Overlap Size (in tokens)" />
                <FormNumberInput value={tokenOverlap}
                  onChange={(e) => {
                    console.log("!!! OVERLAP SIZE CHANGE: ", e.target.value, parseInt(e.target.value));
                    setTokenOverlap(Number(e.target.value));
                  }}
                />
              </FormElement>
            </>
          )
        }
        {
          method === "semantic" && (
            <FormElement>
              <FormLabel label="Number of Clusters (0 for dynamic clustering)" />
              <FormNumberInput value={clusterSize}
                onChange={(e) => {
                  setClusterSize(Number(e.target.value));
                }} />
            </FormElement>
          )
        }
        {
          method === "ner" && (
            <FormElement>
              <FormLabel label="Max Chunk Size" />
              <FormInput value={nerMaxChunkSize}
                onChange={(e) => {
                  setNerMaxChunkSize(Number(e.target.value));
                }} />
            </FormElement>
          )
        }
        {
          method === "content-density" && (
            <>
              <FormElement>
                <FormLabel label="Min Chunk Size" />
                <FormInput value={cdMinChunkSize}
                  onChange={(e) => {
                    setCdMinChunkSize(Number(e.target.value));
                  }} />
              </FormElement>
              <FormElement>
                <FormLabel label="Max Chunk Size" />
                <FormInput value={cdMaxChunkSize}
                  onChange={(e) => {
                    setCdMaxChunkSize(Number(e.target.value));
                  }} />
              </FormElement>
            </>
          )
        }
      </div>
      <Handle type="target" position={Position.Left} style={{ height: "12px", width: "12px" }} />
      <Handle type="source" position={Position.Right} style={{ height: "12px", width: "12px" }} id="document-chunks" />
    </div>
  );
};

export default TextSplittingNode;
